import type { FontAwesomeIcon, IconStyle } from '@builder4/shared/types/icon';

export type IconDictionary = Record<string, FontAwesomeIcon>;
export type IconCategoriesDictionary = Record<string, string[]>;

export class IconManager {
  private dictionary: IconDictionary;
  private categories: IconCategoriesDictionary;

  constructor(dictionary: IconDictionary = {}, categories: IconCategoriesDictionary = {}) {
    this.dictionary = dictionary;
    this.categories = categories;
  }

  getAvailableStyles(name: string): IconStyle[] {
    const icon = this.dictionary[name];
    return icon ? icon.freeStyles : [];
  }

  hasIcon(name: string): boolean {
    return name in this.dictionary;
  }

  getAllIconNames(): string[] {
    return Object.keys(this.dictionary);
  }

  getIconNamesByStyle(style: IconStyle): string[] {
    return Object.keys(this.dictionary).filter((name) =>
      this.dictionary[name].freeStyles.includes(style),
    );
  }

  getCategories(): IconCategoriesDictionary {
    return this.categories;
  }

  getSearchTerms(name: string): string[] {
    const icon = this.dictionary[name];
    return icon ? icon.searchTerms : [];
  }

  getIconLabel(name: string): string {
    const icon = this.dictionary[name];
    return icon ? icon.label : '';
  }
}

let iconManagerInstance: IconManager | null = null;

export const getIconManager = (): IconManager | null => {
  return iconManagerInstance;
};

export const setIconManager = (manager: IconManager): void => {
  iconManagerInstance = manager;
};

export const clearIconManager = (): void => {
  iconManagerInstance = null;
};
